
import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const FuelStationDialog = ({
  open,
  onClose,
  onConfirm,
  penaltyFeeData
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  penaltyFeeData: any;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Due to non-compliance with the prescribed norms, a penalty of ₹{penaltyFeeData?.toLocaleString('en-IN')} will be levied and added to the invoice. This amount has been calculated based on a base value of ₹2,50,000, with the applicable 5% annual increment effective from 26/06/2020 duly considered.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

export const EnergizedFuelDialog = ({
  open,
  onClose,
  onConfirm,
  penaltyFeeData
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  penaltyFeeData: any;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">

        Due to non-compliance with the prescribed norms, a penalty of ₹{penaltyFeeData?.toLocaleString('en-IN')} will be levied and added to the invoice. This amount has been calculated based on a base value of ₹2,50,000, with the applicable 5% annual increment effective from 26/06/2020 duly considered.

      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

export const RoadNotCompliedDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Extension of service/intersecting road shall be required to be constructed at the cost of the fuel station / wayside amenity / company owner seeking permission to access the facility.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

//

export const DecelerationlaneDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Access for fuel stations within closer proximity of 300m shall be provided through a common service road of 7 meters width having sufficient length. The additional length of service road shall be constructed at the cost of the applicant.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

//

export const NearestIntersectionDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Extension of the service road/clustering is required covering the intersection and shall be provided in accordance with IRC:73.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

// IntersectionRoadMedianDialog

export const IntersectionRoadMedianDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Extension of the service road/clustering is required covering the intersection and shall be provided in accordance with IRC:73.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);


export const BothSidecarriagewayDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Access for fuel stations within closer proximity of 300 m shall be provided through a common service road of 7 metres width having sufficient length. The additional length of the service road shall be constructed at the cost of the applicant.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);


export const DividedCarriagewayDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Access for fuel stations within closer proximity of 1000 m shall be provided through a common service road of 7 meters width having sufficient length. The additional length of service road shall be constructed at the cost of the applicant.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);

// Dialog for id 399: Access for fuel stations within closer proximity of 1000m
export const ProximityServiceRoadDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        Access for fuel stations within closer proximity of 1000m shall be provided through a common service road of 7 meters width having sufficient length. The additional length of service road shall be constructed at the cost of the applicant.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
);